import {
  fetchEditorCatalogBootstrap,
  type EditorCategoryTreeItem,
  type EditorCategoryTreeResponse,
} from './editorCatalogApi'

export async function fetchEditorCategoryTree(input?: {
  editorBaseUrl?: string | null
  cacheTtlMs?: number
}): Promise<EditorCategoryTreeResponse> {
  const bootstrap = await fetchEditorCatalogBootstrap(input)
  return bootstrap.tree
}
